import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CriticalityListLayer from "../components/CriticalityListLayer";

const CriticalityListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle="Asset Criticality">

        {/* BlankPageLayer */}
        <CriticalityListLayer />
      </MasterLayout>
    </>
  );
};

export default CriticalityListPage;